<template>
    <div class="grid-fitted">
        <div
            class="grid-item grid-item-full"
            v-for="(condition, conditionIndex) in conditions"
            :key="`${condition.id}_${conditionIndex}`">
            <v-popper2
                :state="condition.isActivated"
                :offset="0"
                class="no-flex"
                position="bottomStart">
                <template #trigger="{popper}">
                    <span
                        @click="popper.toggle"
                        class="chip has-delete"
                        :class="{'stack-s': conditionIndex !== lastConditionIndex}">
                        <condition-item-summary
                            :condition="condition"
                            :field-provider="fieldProvider"/>
                        <r-button type="link" @click.stop="removeCondition(conditionIndex)">
                            <v-icon icon="close-s"/>
                        </r-button>
                    </span>
                </template>
                <template #content="{popper}">
                    <component
                        :key="conditionIndex"
                        :index="conditionIndex"
                        v-bind="getComponentDetails(condition)"
                        @apply-filter="updateFilter($event, popper)"
                        @cancel-filter="cancelFilter(popper)"
                        class="dropdown"/>
                </template>
            </v-popper2>
        </div>
    </div>
</template>

<script>
    import vPopper2 from '@/components/popper/v-popper2';
    import {vIcon} from '@/components/form';
    import BlankFilter from '@/modules/rules-engine/components/condition-builder/filters/blank-filter';
    import DateTimeFilter from '@/modules/rules-engine/components/condition-builder/filters/date-time-filter';
    import BooleanFilter from '@/modules/rules-engine/components/condition-builder/filters/boolean-filter';
    import EnumFilter from '@/modules/rules-engine/components/condition-builder/filters/enum-filter';
    import NumericFilter from '@/modules/rules-engine/components/condition-builder/filters/numeric-filter';
    import TextFilter from '@/modules/rules-engine/components/condition-builder/filters/text-filter';
    import RandomFilter from '@/modules/rules-engine/components/condition-builder/filters/random-filter';
    import FILTER_TYPES from '@/components/query/filter-types';
    import getField from '@/modules/rules-engine/components/common/get-field';

    export default {
        name: 'condition-list',
        components: {
            ConditionItemSummary: () => import('@/modules/rules-engine/components/condition-summary/condition-item-summary'),
            vIcon,
            vPopper2,
        },
        props: {
            /**
             * @type {NormalizedCondition[]}
             */
            conditions: Array,
            fieldProvider: Object,
        },
        computed: {
            lastConditionIndex() {
                return this.conditions.length - 1;
            },
        },
        data() {
            return {
                busCache: null,
            };
        },
        methods: {
            getField,
            removeCondition(index) {
                this.$emit('remove-condition', index);
            },
            cancelFilter({close}) {
                close.call();
            },
            updateFilter({index, condition}, popper) {
                this.cancelFilter(popper);
                this.$emit('update-condition', {index, condition});
            },
            getComponentDetails(condition) {
                const type = condition.definition
                    ? this.fieldProvider.typeResolver(condition.definition)
                    : this.fieldProvider.resolveFieldFromCondition(condition).type;
                const is = (() => {
                    switch (type) {
                        case FILTER_TYPES.text:
                            return TextFilter;
                        case FILTER_TYPES.datetime:
                            return DateTimeFilter;
                        case FILTER_TYPES.numeric:
                            return NumericFilter;
                        case FILTER_TYPES.boolean:
                            return BooleanFilter;
                        case FILTER_TYPES.enum:
                            return EnumFilter;
                        case FILTER_TYPES.random:
                            return RandomFilter;
                        default:
                            return BlankFilter;
                    }
                })();
                // bind properties to the filter
                return {
                    is,
                    condition,
                    class: type === FILTER_TYPES.datetime ? 'datetime-filter' : null,
                    fieldProvider: this.fieldProvider,
                    definition: condition.definition || null,
                };
            },
        },
    };
</script>
<style type="text/css">
    .dropdown.datetime-filter {
        width: 500px;
    }
</style>
